import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LocalFireDepartmentIcon(props: IconProps) {
    return <Icon {...props} iconKey={"local_fire_department"}/>
}
